import Image404 from 'assets/image/404.png'
import * as Logs from 'features/logging'
import { Link } from 'react-router-dom'
import { useDocumentTitle, useMount } from 'shared/hooks'
import { Button } from 'shared/ui'

import css from './NotFoundPage.module.scss'

export function NotFoundPage() {
	useDocumentTitle('404')

	const [log] = Logs.api.useLogsMutation()

	useMount(() => {
		if (import.meta.env.PROD) {
			log({
				args: [window.location.href],
				event_id: 'AppGenericError',
				message: '404 page  {Href}',
				severity: 'Warning'
			})
		}
	})

	return (
		<figure className={css.root}>
			<img
				alt='404'
				className={css.image}
				height={344}
				src={Image404}
				width={546}
			/>

			<figcaption className={css.textBlock}>
				<h1 className={css.title}>Oooopss...</h1>
				<p className={css.lead}>
					Its seems like the page that are you looking for is no longer here
				</p>
				<Button
					as={Link}
					className={css.action}
					to='/campaigns'
					variant='bordered-dark'
				>
					Go home!
				</Button>
			</figcaption>
		</figure>
	)
}
